var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWetransfer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.848 170.218L1.161 91.521C.576 89.966 0 87.435 0 85.46c0-5.672 4.48-10.97 11.498-10.97h128.875c6.446 0 11.11 5.094 11.11 10.97 0 1.767-.594 4.135-.954 5.301l-28.078 79.457c-2.548 7.232-7.424 10.554-13.056 10.554h-.801c-5.83 0-10.714-3.322-12.875-10.138l-12.416-38.038s-1.473-5.41-7.64-5.41c-6.195 0-7.761 5.41-7.761 5.41l-12.516 38.038c-2.17 6.816-7.018 10.138-12.69 10.138h-.78c-5.856.004-10.727-3.327-13.068-10.554zm215.662-17.866c-3.057-.475-4.966.113-7.176 1.342-4.97 3.114-13.047 6.861-22.78 6.861-15.608 0-29.419-9.555-31.553-27.896 0 0 13.888 6.346 35.974 5.596 12.642-.43 23.126-3.241 29.794-7.58 6.779-4.411 7.986-10.969 6.86-18.463C252.078 88.502 235.934 72 209.584 72c-31.679 0-53.621 22.865-53.621 55.502 0 30.138 21.739 55.498 56.728 55.498 16.562 0 28.987-6.237 35.817-10.603 2.291-1.677 4.254-4.244 4.767-7.539.968-6.17-2.832-11.575-8.765-12.506z",
    fill: "#0092D0"
  })));
}

export default SvgWetransfer;